import { Emitter } from "../util/Emitter.mjs";
export class Plex extends Emitter {
    constructor(urls, connection) {
        super();
        this.urls = urls;
        this.connection = connection;
        this.send = (...payload) => {
            this.connection.send([{ relays: this.urls }, payload]);
        };
        this.onMessage = (connection, [{ relays }, [verb, ...payload]]) => {
            this.emit(verb, relays[0], ...payload);
        };
        this.cleanup = () => {
            this.removeAllListeners();
            this.connection.off('receive', this.onMessage);
        };
        this.connection.on('receive', this.onMessage);
    }
    get connections() {
        return [this.connection];
    }
}
//# sourceMappingURL=Plex.mjs.map